export default "__VITE_ASSET__lslD0LOB__"